import React from 'react';
import { Header } from './components/Header';
import { HeroSection } from './components/HeroSection';
import { OpeningHook } from './components/OpeningHook';
import { ProblemSection } from './components/ProblemSection';
import { PainSection } from './components/PainSection';
import { FailedSolutions } from './components/FailedSolutions';
import { AngelReveal } from './components/AngelReveal';
import { AngelAdvantage } from './components/AngelAdvantage';
import { BenefitsSection } from './components/BenefitsSection';
import { TeamShowcase } from './components/TeamShowcase';
import { RealProtection } from './components/RealProtection';
import { UrgencyCTA } from './components/UrgencyCTA';
import { FAQSection } from './components/FAQSection';
import { ImpactPhrases } from './components/ImpactPhrases';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen bg-off-white font-sans text-navy selection:bg-gold selection:text-navy" data-id="element-0">
      <Header data-id="element-1" />

      <main data-id="element-2">
        <div id="hero" data-id="element-3">
          <HeroSection data-id="element-4" />
        </div>
        <OpeningHook data-id="element-5" />
        <ProblemSection data-id="element-6" />
        <PainSection data-id="element-7" />
        <FailedSolutions data-id="element-8" />
        <AngelReveal data-id="element-9" />
        <div id="ventaja" data-id="element-10">
          <AngelAdvantage data-id="element-11" />
        </div>
        <div id="beneficios" data-id="element-12">
          <BenefitsSection data-id="element-13" />
        </div>
        <div id="equipo" data-id="element-14">
          <TeamShowcase data-id="element-15" />
        </div>
        <RealProtection data-id="element-16" />
        <div id="contacto" data-id="element-17">
          <UrgencyCTA data-id="element-18" />
        </div>
        <div id="faq" data-id="element-19">
          <FAQSection data-id="element-20" />
        </div>
        <ImpactPhrases data-id="element-21" />
      </main>

      <Footer data-id="element-22" />
    </div>;
}